'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.feedbackStyle = exports.playButtonStyle = exports.buttonsStyle = exports.wordStyle = exports.arrowStyle = exports.firstEntry = exports.withSound = exports.entryStyle = exports.bubbleWrapStyle = exports.bubbleTransitionSliding = exports.bubbleTransitionOpacity = exports.bubbleStyle = exports.text = exports.span = exports.div = undefined;

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

exports["default"] = content;

var _dictionary = require('./dictionary');

var _defs = require('./defs');

var _icons = require('./icons');

var _assign = require('./assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function content(sourceWord) {
  var entries = (0, _dictionary.getWord)(sourceWord); // If there's even single entry with sound, all will get the same
  // left padding so they're aligned equally

  var anySound = entries.reduce(function (agg, _ref) {
    var sound = _ref.sound;
    return agg || !!sound;
  }, false);
  return div.apply(undefined, [{
    style: bubbleWrapStyle
  }].concat(_toConsumableArray(entries.map(function (_ref2, i) {
    var word = _ref2.word;
    var partOfSpeech = _ref2.partOfSpeech;
    var translation = _ref2.translation;
    var sound = _ref2.sound;
    return div({
      style: (0, _assign2["default"])({}, entryStyle, i === 0 && firstEntry, anySound && withSound)
    }, playButton(sound), span({
      style: wordStyle
    }, text(word)), text(' '), partOfSpeechElement(partOfSpeech), text(' '), span({}, text(translation)), feedbackLink({
      sourceWord: sourceWord,
      word: word,
      partOfSpeech: partOfSpeech,
      translation: translation
    }));
  }))));
}

function playButton(sound) {
  return sound && el('button', {
    "class": _defs.BUTTON_CLASS,
    style: playButtonStyle,
    'data-sound': sound
  });
}

function partOfSpeechElement(_ref3) {
  var ja = _ref3.ja;
  var color = _ref3.color;
  return span({
    style: {
      color: color
    }
  }, text('(' + ja + ')'));
}

function feedbackLink(options) {
  return el('a', {
    href: feedbackUrl(options),
    target: '_blank',
    "class": _defs.BUTTON_CLASS,
    style: feedbackStyle
  });
}

function feedbackUrl(_ref4) {
  var sourceWord = _ref4.sourceWord;
  var word = _ref4.word;
  var partOfSpeech = _ref4.partOfSpeech;
  var translation = _ref4.translation;
  var query = [['form', sourceWord], ['lemma', word], ['translation', translation], ['part_of_speech', partOfSpeech.en]].map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2);

    var label = _ref6[0];
    var value = _ref6[1];
    return 'dictionary_entry_feedback[' + label + ']=' + encodeURIComponent(value);
  }).join('&');
  return _defs.FEEDBACK_URL + '?' + query;
}

var div = exports.div = el.bind(null, 'div');
var span = exports.span = el.bind(null, 'span');

var text = exports.text = function text(value) {
  return document.createTextNode(value);
};

function el(name) {
  var attrs = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
  var element = document.createElement(name);
  Object.keys(attrs).filter(function (attr) {
    return attr !== 'style';
  }).forEach(function (attr) {
    element.setAttribute(attr, attrs[attr]);
  });
  (0, _assign2["default"])(element.style, attrs.style);

  for (var _len = arguments.length, children = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    children[_key - 2] = arguments[_key];
  }

  children.filter(function (x) {
    return !!x;
  }).forEach(function (child) {
    return element.appendChild(child);
  });
  return element;
}

var bubbleStyle = exports.bubbleStyle = {
  display: 'none',
  width: '320px',
  fontSize: '13px',
  lineHeight: '18px',
  color: '#000',
  // Use a value that is slightly smaller than Number.MAX_SAFE_INTEGER, because
  // setting the zIndex to Number.MAX_SAFE_INTEGER doesn't seem to work in IE11.
  zIndex: 9000000000000000
};
var bubbleTransitionOpacity = exports.bubbleTransitionOpacity = {
  transition: 'opacity 0.3s'
};
var bubbleTransitionSliding = exports.bubbleTransitionSliding = {
  transition: 'left 0.2s'
};
var bubbleWrapStyle = exports.bubbleWrapStyle = {
  padding: '5px 10px',
  background: '#fafafa',
  border: '1px solid #c1c1c1',
  borderRadius: '5px',
  boxShadow: '0 0 6px rgba(0, 0, 0, 0.3)'
};
var entryStyle = exports.entryStyle = {
  position: 'relative',
  borderTop: '1px solid #eaeaea',
  paddingTop: '7px',
  paddingRight: '22px',
  paddingBottom: '7px',
  paddingLeft: '0'
};
var withSound = exports.withSound = {
  paddingLeft: '22px'
};
var firstEntry = exports.firstEntry = {
  borderTop: ''
};
var arrowStyle = exports.arrowStyle = {
  width: '10px',
  height: '10px',
  background: '#fafafa',
  border: '1px solid #c1c1c1',
  position: 'absolute',
  transform: 'translateY(50%) translateX(-50%) rotate(45deg)'
};
var wordStyle = exports.wordStyle = {
  fontWeight: 'bold'
};
var buttonsStyle = exports.buttonsStyle = {
  appearance: 'none',
  webkitAppearance: 'none',
  display: 'block',
  position: 'absolute',
  top: '9px',
  width: '15px',
  height: '15px',
  border: '0',
  padding: '0',
  margin: '0',
  cursor: 'pointer',
  opacity: _defs.BUTTON_RESTING_OPACITY,
  transition: 'opacity 0.3s',
  backgroundColor: 'transparent',
  backgroundPosition: 'center',
  backgroundSize: 'contain'
};
var playButtonStyle = exports.playButtonStyle = (0, _assign2["default"])({
  left: '0',
  backgroundImage: 'url("' + _icons.speakerDataUrl + '")'
}, buttonsStyle);
var feedbackStyle = exports.feedbackStyle = (0, _assign2["default"])({
  right: '0',
  backgroundImage: 'url("' + _icons.flagDataUrl + '")',
  textDecoration: 'none'
}, buttonsStyle);